var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIpAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 9.6C6 6.504 8.504 4 11.6 4C14.696 4 17.2 6.504 17.2 9.6C17.2 13.8 11.6 20 11.6 20C11.6 20 6 13.8 6 9.6ZM8.87387 7.68181H9.92785V13.5H8.87387V7.68181ZM12.1232 13.5H11.0692V7.68181H13.251C14.5891 7.68181 15.3021 8.49715 15.3021 9.60795C15.3021 10.7273 14.5805 11.5341 13.2368 11.5341H12.1232V13.5ZM12.1232 8.5625V10.6676H13.0948C13.8788 10.6676 14.2283 10.2273 14.2283 9.60795C14.2283 8.98863 13.8788 8.5625 13.0891 8.5625H12.1232Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpAddress);
export default __webpack_public_path__ + "97131/static/media/ip_Address.377dffaf39d81575f56e52adb22f6516.svg";
export { ForwardRef as ReactComponent };